<template>
  <Modal
    :dialog="show"
    :width="500"
    :title="'Выберите тариф'"
    :contentClass="contentClass || 'esh-theme_parent parentModal'"
    @update:dialog="$emit('update:dialog', false)"
  >
    <template #body>
      <v-card v-for="tariff in tariffs" :key="tariff.id" class="mb-4">
        <v-list-item three-line class="px-6 pt-3">
          <v-list-item-content>
            <div class="overline mb-2">Бесплатный период: {{ tariff.free_days || 'нет' }}</div>
            <v-list-item-title class="headline mb-1">Тариф: {{ tariff.name }}</v-list-item-title>
            <v-list-item-subtitle>Цена: {{ tariff.price | price }} руб.</v-list-item-subtitle>
            <v-divider class="mx-4 mt-4 mb-4"></v-divider>
            <h3 class="mt-2 mb-2">Включает:</h3>
            <ul class="mb-3">
              <li v-for="option in getIncludedOptions(tariff)" :key="option.key">
                <span>{{ option.name}}</span>
              </li>
            </ul>
            <div v-if="isCurrentTariff(tariff.id)" class="green--text text--lighten-1">
              <strong v-if="isCurrentTariffPaused" class="mb-4 red--text text--lighten-1">
                <v-icon class="red--text text--lighten-1">warning</v-icon> Tекущий тариф остановлен!
              </strong>
              <strong v-else>Tекущий тарифный план!</strong>
            </div>
            <div v-if="isNextTariff(tariff.id)" class="blue--text text--lighten-1">
              <strong>Отложенный тарифный план! </strong>
              <info-tooltip
                max-width="270"
                :text="nextTariffTooltipText" />
            </div>
          </v-list-item-content>
        </v-list-item>
        <v-card-actions>
          <v-btn
            v-if="isValidForSelect(tariff)"
            @click="selectTariff(tariff)"
          ><v-icon left>radio_button_unchecked</v-icon> Выбрать</v-btn>
          <div v-else class="red--text text--lighten-1">
            <strong>
              <v-icon class="red--text text--lighten-1">warning</v-icon> Невозможно выбрать тариф
              <ul>
                <li v-for="reason in getInvalidTariffReasons(tariff)" :key="reason">
                  {{ reason }}
                </li>
              </ul>
            </strong>
        </div>
        </v-card-actions>
      </v-card>
      <v-dialog
        v-if="selectedTariff !== null"
        v-model="showConfirmModal"
        max-width="380"
      >
        <v-card>
          <v-card-title class="headline">Внимание!</v-card-title>
          <v-card-text>Оплата за выбранный тариф спишется сразу!</v-card-text>
          <v-card-text v-if="!disableNextSelect">Если Вы хотите применить данный тариф только после окончания срока действия текущего тарифа, пожалуйста, нажмите <b>Отложить</b>.</v-card-text>
          <v-card-text
            v-if="getConstrainOptions(selectedTariff).length"
            class="red--text text--lighten-1"
          >
            Некоторые опции недоступны:
            <ul>
              <li v-for="option in getConstrainOptions(selectedTariff)" :key="option.key">
                <span>{{ option.name }}</span>
              </li>
            </ul>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="!disableNextSelect"
              color="blue darken-1"
              text
              @click="setNextTariff(selectedTariff)"
            >Отложить</v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="setCurrentTariff(selectedTariff)"
            >Применить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template #actions>
      <div></div>
    </template>
  </Modal>
</template>

<script>
import { BASE } from '@/config'
import { Modal, InfoTooltip } from '@/components/common'

export default {
  name: 'TariffSelector',
  components: {
    Modal,
    InfoTooltip,
  },
  props: {
    show: Boolean,
    tariffs: Array,
    currentTariff: Object,
    nextTariff: Object,
    contentClass: String,
    parent: Object,
    disableNextSelect: Boolean
  },
  data() {
    return {
      selectedTariff: {
        tariff: null,
        constains: []
      },
      showConfirmModal: false
    }
  },
  computed: {
    nextTariffTooltipText() {
      return `
        Тариф будет активирован с
        ${this.$options.filters.date(this.nextTariff.start_at)} по
        ${this.$options.filters.date(this.nextTariff.end_at)}.
        Списание за тариф происходит при начале действия.
      `
    },
    isCurrentTariffPaused() {
      return this.currentTariff.paused_start_at != null && this.currentTariff.paused_end_at != null
    },
    isCurrentTaruffPausedNotAvailable() {
      return this.currentTariff.paused_start_at != null && this.currentTariff.paused_end_at == null
    },
  },
  methods: {
    getIncludedOptions(tariff) {
      return BASE.TARIFF.options.filter(o => tariff[o.option])
    },
    getConstrainOptions(tariff) {
      return this.getIncludedOptions(tariff).filter(o => o.user && (this.parent[o.user] === null || this.parent[o.user] === ''))
    },
    isValidForSelect(tariff) {
      if (this.isCurrentTariff(tariff.id)) return false
      const checkOptions = this.getIncludedOptions(tariff).filter(o => o.user)
      return !checkOptions.length || checkOptions.some(o => this.parent[o.user] !== null && this.parent[o.user] !== '')
    },
    getInvalidTariffReasons(tariff) {
      if (this.isCurrentTariff(tariff.id)) return ['Это ваш текущий тариф']
      const checkOptions = this.getIncludedOptions(tariff).filter(o => o.user)
      return checkOptions.map(option => {
        switch (option.user) {
          case 'phone':
            return 'Не указан телефон'
          case 'email':
            return 'Не указан email'
          default:
            return null
        }
      }).filter(option => !!option)
    },
    isCurrentTariff(id) {
      return this.currentTariff && this.currentTariff.tariff.id === id
    },
    isNextTariff(id) {
      return this.nextTariff && this.nextTariff.tariff.id === id
    },
    selectTariff(tariff) {
      this.selectedTariff = tariff
      this.showConfirmModal = true
    },
    setNextTariff(tariff) {
      this.showConfirmModal = false
      this.selectedTariff = null
      this.$emit('update:dialog', false)
      this.$emit('tariff:next', tariff)
    },
    setCurrentTariff(tariff) {
      this.showConfirmModal = false
      this.selectedTariff = null
      this.$emit('update:dialog', false)
      this.$emit('tariff:current', tariff)
    },
  }
}
</script>